export const BreadcrumbsSchema = {
  scriptId: 'breadcrumbs-schema',
  context: 'https://schema.org/',
  type: 'BreadcrumbList',
  scriptType: 'application/ld+json',
  itemType: 'ListItem'
};
